import { render, staticRenderFns } from "./EditShippingModal.vue?vue&type=template&id=663f91a1&scoped=true"
import script from "./EditShippingModal.vue?vue&type=script&lang=js"
export * from "./EditShippingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663f91a1",
  null
  
)

export default component.exports